import controller from './shopping-experience.controller';
import templateBase from './templates/shopping-experience-base.view.html';
// import templateAD from './templates/confirmation-order-view-adaptative.html';

let ShoppingExperienceComponent = {
    template: templateBase,
    controller,
    bindings: {
        shCtrl: '<',
        order:'<'
    }
};


export default ShoppingExperienceComponent;



// WEBPACK FOOTER //
// ./www/components/shopping-experience/shopping-experience.component.js